import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * This guard supports sag links from PublicWeb mails. The sag link might also contain an anchor for a specific Dokumentation id.
 * Examples:
 * /Sag/Vis/f1c758a1-5f71-48e7-9a2e-e7ea5d6215a0
 * /Sag/Vis/f1c758a1-5f71-48e7-9a2e-e7ea5d6215a0#b4c3935e-f60a-478a-9fb6-184c48ea0f47
 */
export class SagRedirectGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const sagId = next.params.sagId;
    const dokId = next.fragment;
    if (dokId) {
      this.router.navigate(['sag', sagId, dokId]);
    } else {
      this.router.navigate(['sag', sagId]);
    }
    return false;
  }
}
